<template>  
    <div class="ObtainOrder">
      <el-dialog  title="单据选择"   width="900px"  :visible.sync="visible"   @close="closeDialog"  append-to-body  :show="show">
          <div class="content_box">
                <div class="content_top ub ub-ac">
                    <el-input v-model="searchText" size="mini" placeholder="输入名称/编号" class="search_box" ></el-input>
                    <el-button type="warning" size="mini" class="search_btn" @click="searchClick">查询</el-button>
                </div>
                <div class="content_table_box">
                    <!-- 选择订单 -->
                    <el-table ref="orderTable" highlight-current-row size="mini" :data="orderTableData" border :height='250' class="tabone_sty" @row-click="orderRowClick" @row-dblclick="orderRowdbClick" :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height: '40px'}">
                        <el-table-column width="40" align="center" fixed="left" prop="aaaa">
                            <template slot="header" slot-scope="scope">
                                <i class="el-icon-s-tools" style="color:#2594ff;font-size:18px"></i>
                            </template>
                            <template slot-scope="scope">{{scope.$index +1 }}</template>
                        </el-table-column>
                        <!-- <el-table-column align="center" label="单据编号" prop="number">
                            <template slot-scope="scope">
                                <span class="span_inner_sty">{{scope.row['number']}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="日期" prop="date">
                            <template slot-scope="scope">
                                <span class="span_inner_sty">{{scope.row['date']}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="摘要" prop="text">
                            <template slot-scope="scope">
                                <span class="span_inner_sty">{{scope.row['text']}}</span>
                            </template>
                        </el-table-column> -->
                        <template v-for="(item,index) in orderConfigData">
                            <el-table-column align="center" :label="item.label" :prop="item.Key" :key="index">
                            <template slot-scope="scope">
                                <span class="span_inner_sty">{{scope.row[item.Key]}}</span>
                            </template>
                            </el-table-column>
                        </template>
                    </el-table>
                    <!-- 选择订单中的商品 -->
                    <GoodsTable class="goods_sty" max="250" :configData="configData" :tableData="goodsTableData" @rowdblclick="goodsRowdbClick" @SelectionChange="SelectionChange"/>
                </div>
                <div class="content_btn_box ub ub-ac">
                    <el-button type="primary" size="mini" style="display:block" @click="saveGoods">确定</el-button>
                    <el-button style="display:block" size="mini" @click="$emit('update:show', false)">取消</el-button>
                </div>
          </div>
      </el-dialog>
    </div> 

</template>  

<script>
import tool from "@/utils/tool";//本地缓存存取

let orderConfigData = [
    {
        label:'单据编号',
        Key:'Number',
    },
    {
        label:'录单日期',
        Key:'Date',
    },
    {
        label:'往来单位',
        Key:'ClientName',
    },
    // {
    //     label:'经手人',
    //     Key:'',
    // },
    // {
    //     label:'部门',
    //     Key:'',
    // },
    {
        label:'仓库',
        Key:'StockName',
    },
    // {
    //     label:'附加说明',
    //     Key:'',
    // },
    {
        label:'摘要',
        Key:'Summary',
    },
    {
        label:'制单人',
        Key:'PersonName',
    },
]

let configData = [
    {
        label:'商品编号',
        field:'BaseCode',
    },
    {
        label:'商品名称',
        field:'FullName',
    },
    {
        label:'数量',
        field:'Qty',
    },
    {
        label:'价格',
        field:'ShowPrice',
    },
    {
        label:'单位',
        field:'UnitName',
    },
    {
        label:'折扣',
        field:'Discount',
    },
    {
        label:'税率',
        field:'Tax',
    },
    {
        label:'含税金额',
        field:'WithTaxTotal',
    },
    {
        label:'备注',
        field:'Memo',
    }
];

export default { 
    data () {  
        return {
            visible: this.show,
            searchText:'',//收索输入框数据
            orderConfigData:orderConfigData,//订单表格配置项
            orderTableData:[],//订单选择表格数据
            configData:configData,//商品选择表格表头配置项
            goodsTableData:[],//商品选择表格数据
            selcetData:[],//选中的商品数据
            backData:{}//传递惠页面的数据
        };  
    },  
    props: {  
        show: {  
            type: Boolean,  
            default: false 
        },
        // 获取单据列表接口需要参数
        VchType:[Number,String],
        BtypeId:[Number,String]
    },
    methods:{
        // 初始化订单列表数据
        initTableData(){
            let params = {
                user_id:tool.getLocal("userid"),
                session_id:tool.getLocal("sessionid"),
                VchType:this.VchType,//单据类型ID
                BtypeId:this.BtypeId,//单位id
                Number:this.searchText
            }
            this.request.post('/index/Order_List/displaylist', {jparams:JSON.stringify(params)})
                .then(res => {
                // 接收后端发送回来的数据
                    // console.log('+++++++++>',res)
                    // if(res.data.length !== 0){
                        this.goodsTableData = []
                        this.orderTableData = res.data;
                        this.$refs.orderTable.setCurrentRow(res.data[0]);
                        // this.backData.baseData = res.data[0];//赋值回传数据的基本信息
                        this.initGoodsTableData(res.data[0].VchCode)
                    // }
                })
                .catch(err => {
                    console.log(err);
            });
        },
        // 初始化商品表格数据
        initGoodsTableData(data){
            let params = {
                user_id:tool.getLocal("userid"),
                session_id:tool.getLocal("sessionid"),
                VchCode:data,//单据ID
            }
            this.request.post('/index.php/index/Order_List/getone', {jparams:JSON.stringify(params)})
                .then(res => {
                // 接收后端发送回来的数据
                    // console.log('==================>',res)
                    this.goodsTableData = res.Goods;
                    this.backData = res;
                })
                .catch(err => {
                    console.log(err);
            });
        },
        // 点击查询按钮
        searchClick(){
            this.initTableData();
        },
        // 单击订单表格某一行
        orderRowClick(data){
            this.initGoodsTableData(data.VchCode);
        },
        // 双击订单表格某一行
        orderRowdbClick(data){
            this.backData.Goods = this.goodsTableData;
            this.$emit('backOrderData',this.backData);
            this.closeDialog();
        },
        // 双击商品表格某一行
        goodsRowdbClick(data){
        
        },
        // table表格select选项框改变触发
        SelectionChange(data) {
            this.selcetData = data;
            // console.log(this.selcetData);
        },
        // 点击确定按钮
        saveGoods(){
            this.backData.Goods = this.selcetData;
            this.$emit('backOrderData',this.backData)
            this.$emit('update:show', false)
        },
        // 关闭弹出框前回调
        closeDialog(){
            this.selcetData = [];
            this.backData = {};
            this.$emit('update:show', false)
        },
    },
    watch: {  
        show () {  
            this.visible = this.show;
            this.initTableData();
        },
        
    }
};  
</script>

<style lang="less">
    .content_box{
        width: 100%;
        height: auto;
        .content_top{
            .search_box{
                width: 200px;
                display: block;
                margin-right: 20px;
            }
        }
        .content_table_box{
            padding: 0 2px;
            width: 100%;
            .span_inner_sty{
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
            }
            .goods_sty{
                margin: 20px auto;
            }
        }
        .content_btn_box{
            width: 100%;
            height: 40px;
            -webkit-box-pack:end;
            box-pack:end;
        }	
    }
.ub {
    display: -webkit-box !important;
    display: box !important;
    position: relative;
}

.ub-ac {
    -webkit-box-align: center;
    box-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/ObtainOrder/ObtainOrder.vue